module.exports = __webpack_public_path__ + "img/puzzle_29.4950d618.png";